import { RouteRecordRaw } from 'vue-router';

// ファイルダウンロード関連
export const fileDownloadRoutes: Array<RouteRecordRaw> = [
  {
    name: 'FileDownload',
    component: () => import('@/components/pages/file-download/index.vue'),
    path: '/file-download',
    meta: {
      title: 'ファイルダウンロード',
      requiredAuthority: 'FILE_DOWNLOADS',
    },
  },
];
